import { render } from "./NsiList.vue?vue&type=template&id=3fe0d95f&scoped=true"
import script from "./NsiList.vue?vue&type=script&lang=js"
export * from "./NsiList.vue?vue&type=script&lang=js"

import "./NsiList.vue?vue&type=style&index=0&id=3fe0d95f&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fe0d95f"]])

export default __exports__